import styled, { css } from 'styled-components';

const focusModifier = ({ inFocus }) => inFocus && css`
  border: solid 1px #1082ea;
`;

export default styled.div`
  height: 56px;
  display: flex;
  justify-content: start;
  align-items: center;
  border-radius: 4px;
  border: solid 1px #d4dce8;
  background-color: #ffffff;

  ${focusModifier}

  input {
    border: 1px solid #999;
    height: 56px;
    color: #32383e;
    font-size: 16px;
    display: flex;
    justify-content: start;
    align-items: center;
    border: none;
    flex: 1;
    background: transparent;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    &:focus {
      outline: none;
      text-overflow: clip;
    }
  }
`;

